var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStockBoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C3.55228 2 4 2.44772 4 3V36H8V35C8 34.4477 8.44772 34 9 34C9.55228 34 10 34.4477 10 35V36H13V35C13 34.4477 13.4477 34 14 34C14.5523 34 15 34.4477 15 35V36H18V35C18 34.4477 18.4477 34 19 34C19.5523 34 20 34.4477 20 35V36H23V35C23 34.4477 23.4477 34 24 34C24.5523 34 25 34.4477 25 35V36H28V35C28 34.4477 28.4477 34 29 34C29.5523 34 30 34.4477 30 35V36H33V35C33 34.4477 33.4477 34 34 34C34.5523 34 35 34.4477 35 35V36H37C37.5523 36 38 36.4477 38 37C38 37.5523 37.5523 38 37 38H3C2.44772 38 2 37.5523 2 37V3C2 2.44772 2.44772 2 3 2ZM34.4473 6.10558C34.9413 6.35257 35.1415 6.95324 34.8945 7.44722L30.8604 15.5155C30.0789 17.0785 28.1321 17.6454 26.6336 16.7463L25.3376 15.9687C24.8381 15.669 24.1891 15.858 23.9286 16.379L20.4473 23.3416C19.9391 24.358 18.9003 25 17.764 25H15.0293C14.7064 25 14.4033 25.156 14.2156 25.4188L9.81381 31.5812C9.4928 32.0307 8.86825 32.1347 8.41884 31.8137C7.96943 31.4927 7.86533 30.8682 8.18634 30.4188L12.5881 24.2563C13.1512 23.4679 14.0605 23 15.0293 23H17.764C18.1428 23 18.489 22.786 18.6584 22.4472L22.1398 15.4845C22.9213 13.9215 24.8681 13.3546 26.3665 14.2537L27.6626 15.0313C28.1621 15.331 28.811 15.1421 29.0715 14.621L33.1057 6.55279C33.3526 6.05881 33.9533 5.85859 34.4473 6.10558Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockBoom);
export default __webpack_public_path__ + "static/media/stock-boom.1db0dee0db3a9d57a96d5a60197ee924.svg";
export { ForwardRef as ReactComponent };